const ACTIVE_STATUS = 'active';
const APPROVED_STATUS = 'approved';
const ACCEPTED_STATUS = 'accepted';
const CANCELLED_STATUS = 'cancelled';
const CLOSED_STATUS = 'closed';
const INACTIVE_STATUS = 'inactive';
const PENDING_STATUS = 'pending';
const REJECTED_STATUS = 'rejected';

const NOTIFICATION_TYPE_ERROR = 'error';
const NOTIFICATION_TYPE_NOTIFICATION = 'notification';

const SAT_ACTIVE = 'active';
const SAT_CANCELLED = 'cancelled';

const USER_CONFIRMED = 'CONFIRMED';
const USER_FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD';
const USER_UNCONFIRMED = 'UNCONFIRMED';
const USER_ERROR_NOT_FOUND = 'UserNotFoundException';

export const accountStatusColor = {
  [APPROVED_STATUS]: 'success',
  [CLOSED_STATUS]: 'secondary',
  [PENDING_STATUS]: 'warning',
  [REJECTED_STATUS]: 'error',
};

export const notificationTypeStatusColor = {
  '': 'secondary',
  [NOTIFICATION_TYPE_ERROR]: 'error',
  [NOTIFICATION_TYPE_NOTIFICATION]: 'success',
};

export const peopleStatusColor = {
  [ACCEPTED_STATUS]: 'secondary',
  [ACTIVE_STATUS]: 'success',
  [CANCELLED_STATUS]: 'error',
  [INACTIVE_STATUS]: 'info',
  [PENDING_STATUS]: 'warning',
  [REJECTED_STATUS]: 'error',
};

export const satStatusColor = {
  [SAT_ACTIVE]: 'success',
  [SAT_CANCELLED]: 'error',
};

export const userStatusColor = {
  [USER_CONFIRMED]: 'success',
  [USER_FORCE_CHANGE_PASSWORD]: 'warning',
  [USER_UNCONFIRMED]: 'error',
  [USER_ERROR_NOT_FOUND]: 'error',
};
